import React from "react";
import { useQuery } from "@apollo/client";
import { message } from "antd";
import { useTranslation } from "react-i18next";

// graphql
import GET_BOOKING_APPOINTMENT from "graphql/queries/GetBookingAppointment";

// custom components
import GroupModal from "./GroupModal";
import OneOnOneModal from "./OneOnOneModal";

type BookingModalProps = {
  visible: boolean;
  onCloseModal: () => void;
  state: {
    classId: number;
    classType: string;
    filteredLanguageId?: number;
    classCredit: number;
  };
};

function BookingModal(props: BookingModalProps) {
  const { t } = useTranslation("book_a_class");
  const { visible, onCloseModal, state } = props;

  // QUERIES
  const { loading, data } = useQuery(GET_BOOKING_APPOINTMENT, {
    fetchPolicy: "network-only",
  });

  if (loading) return null;

  const credits = data?.me.credits;
  const currentLevelId = data?.me.currentLevel.id;
  const { classCredit } = state;

  const handleBookingError = (errors: any) => {
    const errorMessages = errors.map((e: any) => e.message).join("\n");
    message.error(errorMessages, 3);
  };

  const handleBookingSuccess = () => {
    message.success(t("Class successfully booked!"));
  };

  const renderModal = () => {
    if (state.classType.toLowerCase() === "small group") {
      return (
        <GroupModal
          visible={visible}
          onCloseModal={onCloseModal}
          credits={credits}
          classCredit={classCredit}
          state={{ classId: state.classId }}
          handleBookingError={handleBookingError}
          handleBookingSuccess={handleBookingSuccess}
        />
      );
    }
    if (state.classType.toLowerCase() === "1 on 1") {
      return (
        <OneOnOneModal
          visible={visible}
          onCloseModal={onCloseModal}
          credits={credits}
          classCredit={classCredit}
          state={{
            classId: state.classId,
            defaultLevelId: currentLevelId,
            filteredLanguageId: state.filteredLanguageId,
          }}
          handleBookingError={handleBookingError}
          handleBookingSuccess={handleBookingSuccess}
        />
      );
    }
    return null;
  };

  return renderModal();
}

export default BookingModal;
